// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"08f78a7c","43":"12ede3aa","217":"886b7109","255":"94ae247b","391":"7d5e30be","555":"d674c73f"}[chunkId] + ".chunk.js";
};